import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=6cd809b4&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=ts&"
export * from "./HowTo.vue?vue&type=script&lang=ts&"
import style0 from "./HowTo.vue?vue&type=style&index=0&id=6cd809b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd809b4",
  null
  
)

export default component.exports